export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6370.2f0bd9b0.jpg";